'use client'

import Link, { type LinkProps } from '@components/primitives/Link'
import { type TrackingProperties, trackEvent } from '@lib/tracking'
import { type TrackingEvents } from '@lib/tracking/TrackingEvents'
import type { ReactElement } from 'react'

/** Client component taking in children so we can server render the children and make sure they are in the DOM at server render
 * https://nextjs.org/docs/app/building-your-application/rendering/composition-patterns#supported-pattern-passing-server-components-to-client-components-as-props
 */
export default function ClientLinkWithServerChildren({
  children,
  trackingEvent,
  trackingProperties,
  ...linkProps
}: {
  children: ReactElement
  trackingEvent?: TrackingEvents
  trackingProperties?: TrackingProperties
} & LinkProps) {
  return (
    <Link
      {...linkProps}
      onClick={() => {
        trackingEvent
          ? trackEvent(trackingEvent, trackingProperties)
          : undefined
      }}
    >
      {children}
    </Link>
  )
}
